import { Typography } from '@workspace/ui/components/Typography';
import { useBreakpoint } from '@workspace/ui/hooks/useBreakpoint';
import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import Skeleton from 'react-loading-skeleton';

import { company } from '~/company/Company';

import type { ProductTitleProps } from './interfaces';
import styles from './ProductTitle.module.scss';

const ProductTitle = ({ children, isLoading }: ProductTitleProps) => {
  const { isMobile } = useBreakpoint();
  if (isLoading) {
    return (
      <>
        <Skeleton containerClassName={styles.skeleton} />
        <Skeleton containerClassName={styles.skeleton} />
        {!company.is('mcosmetic') && (
          <Skeleton containerClassName={styles.skeleton} />
        )}
      </>
    );
  }
  const isMarketplace =
    company.isMarketplaceVariant || company.useMarketplaceProductLayout;

  const TitleComponent = company.match({
    mcosmetic: isMobile
      ? Typography.Header200Semibold
      : Typography.Header300Semibold,
    default: isMarketplace
      ? isMobile
        ? Typography.Header200Semibold
        : Typography.Header300Medium
      : isMobile
        ? Typography.Header300Medium
        : Typography.Header100Medium,
  });

  return (
    <div className={styles.root}>
      <TitleComponent
        as="h1"
        className={classes([
          styles.title,
          isMarketplace && styles.titleMarketplace,
        ])}
        title={`${children}`}
      >
        {children}
      </TitleComponent>
    </div>
  );
};

export default observer(ProductTitle);
